import {
  Amount,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from '@razorpay/blade/components';
import { SalaryStructureComponent } from 'components/SalaryStructure/types';
import React from 'react';

const PreviewCtcTable = ({
  components,
  columnTitles,
}: {
  components: SalaryStructureComponent[];
  columnTitles: string[];
}) => {
  return (
    <Table
      rowDensity="compact"
      backgroundColor="transparent"
      data={{
        nodes: components,
      }}>
      {(tableData) => {
        return (
          <>
            <TableHeader>
              <TableHeaderRow>
                {columnTitles.map((title, index) => (
                  <TableHeaderCell key={title} textAlign={index === 0 ? 'left' : 'right'}>
                    {title}
                  </TableHeaderCell>
                ))}
              </TableHeaderRow>
            </TableHeader>
            <TableBody>
              {tableData.map((item) => {
                return (
                  <TableRow key={item.id} item={item}>
                    <TableCell>
                      {item.salaryComponent.settings.behaviour.displayBehaviour?.displayName ??
                        item.salaryComponent.name}
                    </TableCell>
                    <TableCell textAlign="right">
                      <Amount value={Number(item.formula ?? 0)} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </>
        );
      }}
    </Table>
  );
};
export default PreviewCtcTable;
